import { z } from 'zod';

const isProduction = import.meta.env.PROD;

const httpsInProduction = (value: string): boolean => !isProduction || value.startsWith('https://');

const publicEnvSchema = z.object({
  appUrl: z.url().refine(httpsInProduction).default('http://localhost:3000'),
  apiBaseUrl: z.url().refine(httpsInProduction, {
    message: 'VITE_API_BASE_URL must use https:// in production',
  }),
});

export const publicEnv = publicEnvSchema.parse({
  appUrl: import.meta.env.VITE_APP_URL,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
});
